module.exports = __webpack_public_path__ + "static/media/launch.4ac96ea6.png";